<template>
  <div class="disease">
    <tabs :isSubject="true"></tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="cons-div">
      <div class="item-div" v-for="(item, index) in list" :key="index" @click="handleClick(item)">
        <items :dataProps="item" :typeTxt="'subject'"></items>
      </div>
    </van-list>
  </div>
</template>
<script>
import items from './components/items.vue'
import tabs from './components/tabs.vue'
import { getTopicList } from '../../api/questionBank'
import { getShareInfo } from '@/utils/wxShare'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    items,
    tabs
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 15,
      classCode: '',
      difficultyLevel: '',
      load: false
    }
  },
  mounted () {
    getShareInfo({
      title: 'iEP-心电图分类题库',
      titleTimeLine: 'iEP-海量心电图分类题库，进阶心电王者',
      desc: '解锁更多题目，进阶心电王者',
      link: window.location.href + `&bankShare=true`,
      linkTimeLine: window.location.href + `&bankShare=true`,
      images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
    })
  },
  methods: {
    handleClick (item) {
      this.$router.push({
        path: `/questionDetails?questionId=${item.questionId}&entrance=8&channel=8&answerStatus=${item.answerStatus}${item.answerStatus !== '3' ? `&classCode=${this.$route.query.classCode}&difficultyLevel=${this.$route.query.difficultyLevel}` : ''}`
      })
    },
    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      this.$toast.loading({ message: '加载中...' })
      let params = {
        pageNum: this.pageNo,
        pageSize: this.pageSize,
        classCode: this.$route.query.classCode,
        difficultyLevel: this.$route.query.difficultyLevel,
      }
      getTopicList(params)
        .then(res => {
          this.load = false
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }
            if (res.data.list.length < this.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
            }
            this.loading = false
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.disease {
  min-height: 100vh;
  background-color: #F7F9FB;

  .cons-div {
    box-sizing: border-box;
    padding: 8px 15px;
    display: flex;
    flex-wrap: wrap;

    .item-div {
      width: 111px;
      background-color: #Fff;
      margin-bottom: 8px;
      position: relative;
      padding: 0 8px;
      height: 170px;
      padding-bottom: 4px;
      box-sizing: border-box;

      &:nth-child(3n-1) {
        margin: 0 6px;
        margin-bottom: 8px;
      }
    }
  }
}

/deep/ .van-list__finished-text {
  width: 100%;
  display: block;
}

/deep/ .van-list__loading {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/questionBank/subject.vue